<template>
  <div class="p20 bg-white main">
    <div class="mt20 mb20">
      <span class="title1">待质检区</span>
    </div>
    <div class="bg-gray">
      <div class="mt20 mb20" style="overflow: hidden;">
        <div class="pt20 fl">
          子账户编号: &nbsp;&nbsp;{{client_name_code}}
        </div>
        <div class="fr">
          <button @click="submit" class="ivu-btn ivu-btn-primary ml10">提交</button>
        </div>

      </div>
      <Table :loading="loading" class="mt20" border :columns="table_data.columns" :data="table_data.data">
      </Table>
    </div>
    <Paging :page-data="page_data" v-on:setPage="setPage" :selectSize="true" @setSize="chooseSize"></Paging>
    <div v-if="list.length" class="table-box">
      <h1 class="mt20">商品列表</h1>
      <table class="ivu-table-border mt10">
        <tr>
          <th width="10%">SKU</th>
          <th width="10%">中文名称</th>
          <th width="10%">尺寸</th>
          <th width="10%">颜色</th>
          <th width="10%">上传图片</th>
          <th width="10%">其他备注</th>
          <th width="5%">操作</th>
        </tr>
        <tr v-for="(item,index) in list">
          <td>
            <input v-model="item.sku" @keyup="skuChanged($event,index)" onKeyUp="value=value.replace(/[\W]/g,'')"
              maxlength="15" placeholder="SKU" class="w200 ivu-input ivu-input-default">
          </td>
          <td>
            <input v-model="item.product_name" maxlength="20" placeholder="商品名称"
              class="w200 ivu-input ivu-input-default">
          </td>

          <td>
            <input v-model="item.size" class="w200 ivu-input ivu-input-default" maxlength="20" placeholder="尺寸">
          </td>
          <td>
            <input v-model="item.color" class="w200 ivu-input ivu-input-default" maxlength="20" placeholder="颜色">
          </td>
          <td>
            <div class="upload-img">
              <img v-if="item.image_url" class="mr10" :src="item.image_url" height="40" />
              <a @click="triggerFile(index)">{{item.image_url?'修改':'上传'}}图片</a>
            </div>
          </td>
          <td>
            <input v-model="item.remark" placeholder="备注" class="w200 ivu-input ivu-input-default" maxlength="30">
          </td>
          <td width="100">
            <a @click="delSku(index)" class="red">删除</a>
          </td>
        </tr>
      </table>
    </div>
    <div class="tr mt20">
      <button @click="addInfo" class="ivu-btn ivu-btn-primary">新增商品</button>
    </div>
    <form id="uploadForm" style="display: none;"><input type="file" id="file" @change="uploadFile($event)">
    </form>

  </div>
</template>

<script>
  import Paging from '@/components/common/paging'
  export default {
    components: {
      Paging
    },
    data() {
      return {
        loading: false,
        show_info: false,
        form_data: {},
        client_name_code: '',
        screen_data: {
          client_code: '',
          warehouse_id: '',
          pageNum: 1,
          pageSize: 10,
        },
        page_data: { //分页数据
          pageTotal: 0, //总页数
          dataTotal: 0, //总条数
          pageIndex: 1, //当前页数
          pageCount: 8 //页面最多显示几个分页组
        },
        table_data: { //列表数据
          columns: [],
          data: []
        },
        list: [{
          color: '',
          image_url: '',
          product_name: '',
          remark: '',
          size: '',
          sku: ''
        }], //信息
        index: 0,
      }
    },
    methods: {
      delSku(index) {
        this.list.splice(index, 1)
      },
      addInfo() { //录入信息
        this.list.push({
          color: '',
          image_url: '',
          product_name: '',
          remark: '',
          size: '',
          sku: ''
        })
      },
      triggerFile(index) { //触发input
        this.index = index;
        $("#file").trigger('click');
      },
      uploadFile(event) {
        const _this = this;
        let formData = new FormData();
        let _file = event.target.files[0];
        formData.append('file', _file);
        this.$axios.post("/common/image/upload", formData, {
          headers: {
            "Content-Type": "application/json",
            noShowError: true
          }
        }).then(res => {
          console.log(res)
          this.list[this.index].image_url = res;
          document.getElementById("uploadForm") && document.getElementById("uploadForm").reset(); //清除input
        })
      },
      submit() {
        if (!this.list || !this.list.length) {
          this.$Message.info('请录入商品')
          return;
        }
        let client_code = localStorage.getItem('client_code');
        let warehouse_id = localStorage.getItem('warehouse_id');
        this.$axios.post("/zj/check/bill/pending/confirm?client_code=" + client_code + '&warehouse_id=' + warehouse_id,
            [...this.list], {
              headers: {
                'Content-Type': 'application/json'
              }
            })
          .then(res => {
            if (res.success) {
              this.$Message.success('提交成功')
              this.$router.push('/tuihuozhijian/zhijiandan')
            }
          });
      },
      /*
       * 分页
       */
      setPage(page) {
        this.screen_data.pageNum = this.page_data.pageIndex = page;
        this.getList();
      },
      chooseSize(size) {
        this.page_data.pageSize = this.screen_data.pageSize = size;
        let p = Math.ceil(this.page_data.dataTotal / this.page_data.pageSize);
        if (this.page_data.pageIndex > p) {
          this.page_data.pageIndex = this.screen_data.pageNum = p;
        }
        this.getList();
      },
      /*
       * 获取列表
       */
      getList() {
        if (!this.screen_data.client_code) {
          this.list = []
          return false;
        }
        this.$axios.get("/warehouse/in/check/pending", {
          params: this.screen_data
        }).then(res => {
          this.loading = false;
          if (res.success && res.data && res.data.length) {
            this.table_data.data = res.data;
          } else {
            this.table_data.data = []
          }
          this.page_data.pageTotal = res.pageTotal;
          this.page_data.dataTotal = res.totalSize;
        })
      },
      setColumns() {
        let arr = [];
        arr = [{
          title: '快递单号',
          key: 'waybill',
          tooltip: true,
          minWidth: 200,
        }, {
          title: '入库单号',
          key: 'in_bill_no',
          tooltip: true,
          minWidth: 200,
        }, {
          title: '入库时间',
          key: 'create_date',
          minWidth: 190,
          tooltip: true,
        }, {
          title: '操作',
          width: 200,
          render: (h, params) => {
            let doms = [];
            doms.push(h('span', {
              style: {
                cursor: "pointer",
                color: "#0062da"
              },
              on: {
                click: () => {
                  this.removePending(params.row.in_bill_no)
                }
              }
            }, '从待质检区移除'));
            return h("div", doms);
          }
        }];
        return arr;
      },
      removePending(in_bill_no) { //移除待质检区
        this.$axios.delete("/warehouse/in/check/pending?in_bill_no=" + in_bill_no).then(res => {
          if (res.success) {
            this.$Message.success('移除成功')
            this.getList();
          }
        })
      },
      skuChanged(e, index) {
        this.list[index].sku = e.target.value.toUpperCase()
      },
      create() { //创建质检单
        this.$axios.post("/check/bill/pending/confirm", this.$qs.stringify({
            client_code: localStorage.getItem('client_code'),
            warehouse_id: localStorage.getItem('warehouse_id')
          }))
          .then(res => {
            if (res.success) {
              this.$Message.info('录入成功')
              this.$router.push({
                url: '/tuihuozhijian/zhijiandan'
              })
            }
          });
      }
    },
    created() {
      this.table_data.columns = this.setColumns();
      this.client_name_code = localStorage.getItem('client_name_code') || ''
      this.screen_data.client_code = localStorage.getItem('client_code') || ''
      this.screen_data.warehouse_id = localStorage.getItem('warehouse_id') || ''
      this.screen_data.biz_type = 0;
      if (!this.screen_data.warehouse_id) {
        this.$Message.info('请选择仓库');
        return false
      }
      if (!this.screen_data.client_code) {
        this.$Message.info('请选择子账户');
        return false
      }
      this.getList()
    }
  }
</script>

<style scoped>
  table th,
  table td {
    text-align: center;
    border-right: 1px solid #e9eaf5;
  }

  .upload-img {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>


// WEBPACK FOOTER //
// src/pages/tuihuozhijian/in/pendding.vue